module.exports = __webpack_public_path__ + "img/image21.43a216c8.svg";